module.exports = __webpack_public_path__ + "static/media/clinica_medica_inteligente.f1034ca2.jpeg";